
import {
  WIFI, TV, FREE_PARKING, KITCHEN, DEDICATED_WORKSPACE, POOL, LIFT, type Amenity,
} from "./amenities"


export interface RoomConfig {
  id: string
  code: string
  name: string
  fullName: string
  tagline: string
  subtitle: string
  /** Number of guests included in the base price */
  capacity: number
  pricePerNight: number
  amenities: Amenity[]
  dialog: string
}

export const TEMPULA_ROOMS: Record<string, RoomConfig> = {
  "tempula-dh-001": {
    id: "tempula-dh-001",
    code: "T-DH-001",
    name: "Dhuppi",
    fullName: "Dhuppi Room",
    tagline: "Feel at Home | Away from Home",
    subtitle: "Dhuppi room in rental unit in Samsing, Kalimpong",
    capacity: 3,
    pricePerNight: 3000,
    amenities: [WIFI, TV, FREE_PARKING, KITCHEN, DEDICATED_WORKSPACE, POOL, LIFT],
    dialog: "Tucked under tall pines, this A-frame wooden cottage is where nature meets comfort. With its striking red-trimmed roof, stone base, and handcrafted log walls, Dhuppi welcomes you into a warm, earthy retreat. Inside, the high timber ceiling and all-wood interiors glow under soft pendant lights, while a cozy log bed and rustic bench invite you to slow down. Sunlight filters through sheer curtains, and the scent of pine lingers in the air. Step out onto the patterned stone porch and you’re instantly among the trees. It’s not just a stay, it’s a quiet moment carved out of the forest.",
  },
  "tempula-ne-001": {
    id: "tempula-ne-001",
    code: "T-NE-001",
    name: "Neora",
    fullName: "Neora Room",
    tagline: "Elegant Stays | Timeless Comfort",
    subtitle: "Neora room in rental unit in  Samsing, Kalimpong",
    capacity: 3,
    pricePerNight: 3000,
    amenities: [WIFI, TV, FREE_PARKING, KITCHEN, DEDICATED_WORKSPACE, POOL, LIFT],
    dialog: "The room feels alive, wrapped entirely in wood and tree bark like a nest tucked into the forest. Weathered planks run across the ceiling, still bearing the grain and knots of their past, while walls clad in layered bark give off a warm, earthy scent when the sun hits them. Just beyond a wooden door, a balcony extends outward opening to a sweep of hills and sky.",
  },
  "tempula-mu-001": {
    id: "tempula-mu-001",
    code: "T-MU-001",
    name: "Murti",
    fullName: "Murti Room",
    tagline: "Made for Comfort | Just Like Home",
    subtitle: "Murti room in rental unit in  Samsing, Kalimpong",
    capacity: 3,
    pricePerNight: 3000,
    amenities: [WIFI, TV, FREE_PARKING, KITCHEN, DEDICATED_WORKSPACE],
    dialog: "The room breathes cool and quiet, its thick stone walls holding the hush of the hills. Rough-hewn slabs, stacked by hand, catch the morning light that slips through a wooden-framed window. It feels less like a room and more like a calm pocket extracted out of the river itself, part of a homestay where nature isn't just the view, it's in the walls.",
  },
  "tempula-pa-001": {
    id: "tempula-pa-001",
    code: "T-PA-001",
    name: "Paiyuu",
    fullName: "Paiyuu Room",
    tagline: "Luxury Living | Redefined Comfort",
    subtitle: "Paiyuu room in rental unit in  Samsing, Kalimpong",
    capacity: 2,
    pricePerNight: 2500,
    amenities: [WIFI, TV, FREE_PARKING, KITCHEN, DEDICATED_WORKSPACE, POOL, LIFT],
    dialog: "Perched on a quiet mountainside, this cottage blends stone, wood, and open skies. The warm cream walls and rustic stone base sit gently among tea bushes and blooming bougainvillea, with rolling hills stretching endlessly beyond.  Inside, the room is all warmth and simplicity: a high, wood-paneled ceiling, log-framed bed, and sunlit windows draped in soft blue curtains. Morning light pours in, making the wooden floors glow. But the real heart of the stay is the balcony. Wide, covered, and lined with white railings, it opens to a breathtaking panorama of forested valleys and distant peaks. Sit with a cup of tea, feel the mountain breeze, and let the silence do the talking. It’s not luxury, it’s peace. The kind of place where you wake up to birdsong and fall asleep to the sound of the hills.",
  },
  "tempula-gu-001": {
    id: "tempula-gu-001",
    code: "T-GU-001",
    name: "Guras",
    fullName: "Guras Room",
    tagline: "Nature's Retreat | Pure Serenity",
    subtitle: "Guras room in rental unit in  Samsing, Kalimpong",
    capacity: 2,
    pricePerNight: 2500,
    amenities: [WIFI, TV, FREE_PARKING, KITCHEN, DEDICATED_WORKSPACE, POOL, LIFT],
    dialog: "Perched on a quiet mountainside, this cottage blends stone, wood, and open skies. The warm cream walls and rustic stone base sit gently among tea bushes and blooming bougainvillea, with rolling hills stretching endlessly beyond.  Inside, the room is all warmth and simplicity: a high, wood-paneled ceiling, log-framed bed, and sunlit windows draped in soft blue curtains. Morning light pours in, making the wooden floors glow. But the real heart of the stay is the balcony. Wide, covered, and lined with white railings, it opens to a breathtaking panorama of forested valleys and distant peaks. Sit with a cup of tea, feel the mountain breeze, and let the silence do the talking. It’s not luxury, it’s peace. The kind of place where you wake up to birdsong and fall asleep to the sound of the hills.",
  },
}
